import React, { useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { FiSearch } from "react-icons/fi";
import folderIcon from "../../Asset/folder icon.svg";
import { ReactSVG } from "react-svg";
import { GoArrowUpRight } from "react-icons/go";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import Footer from "../../component/Footer/Footer";
import FAQ from "../../component/Faqs/FAQ";
import ContactUs from "../../component/contact-Us/ContactUs";
import { useInView } from "react-intersection-observer";

const bannerImage = process.env.PUBLIC_URL + "/images/support-banner-image.svg";

const articlesFolder = [
  {
    name: "Getting Started",
    summary: "Set up Zero Typing quickly and start dictating with ease.",
    articles: 10,
  },
  {
    name: "Customizing Zero Typing",
    summary: "Adjust settings to fit your workflow and style.",
    articles: 4,
  },
  {
    name: "Troubleshooting & FAQ",
    summary: "Find quick fixes and answers to common  questions.",
    articles: 16,
  },
];

const articlesFolder1 = [
  {
    name: "Billing",
    summary: "",
    articles: 3,
  },
  {
    name: "Plans & Pricing",
    summary:
      "See Zero’s plans, pricing, and discounts to find the best fit for your workflow.",
    articles: 12,
  },
  {
    name: "Data Privacy",
    summary: "Learn how Zero Typing keeps your data secure and private.",
    articles: 2,
  },
];


const Support = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { ref: tagRef, inView: tagView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: iconRef, inView: iconView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingBannerRef, inView: headingBannerView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <>
      <div className="bg-white p-4 max-w-screen-2xl mx-auto flex flex-col xl:gap-20 lg:gap-16 gap-12  ">
        <Navbar />
        <div className=" flex flex-col gap-10 mt-20 md:mt-0 ">
          <div className="relative  overflow-hidden rounded-2xl">
            <div className="absolute top-0 left-0 w-full h-full flex flex-col z-0">
              <div className="relative flex-[1] bg-gradient-to-t from-[#3AB1F650]  to-[#D8EFFD] rounded-2xl">
                <svg
                  className="absolute top-0 left-0 w-full h-full  rounded-2xl z-[4]"
                  viewBox="0 0 1000 1350"
                  preserveAspectRatio="none"
                >
                  <path
                    id="orbitPath"
                    d="
        M40,0 
        H960 
        A40,40 0 0 1 1000,40 
        V1310 
        A40,40 0 0 1 960,1350 
        H40 
        A40,40 0 0 1 0,1310 
        V40 
        A40,40 0 0 1 40,0 
        Z"
                    fill="none"
                    stroke="transparent"
                  />

                  {/* Orbiting Glow Circle */}
                  <circle r="300" fill="url(#glow)" filter="url(#blur)">
                    <animateMotion
                      repeatCount="indefinite"
                      dur="20s"
                      rotate="auto"
                    >
                      <mpath href="#orbitPath" />
                    </animateMotion>
                  </circle>

                  <circle r="300" fill="url(#glow)" filter="url(#blur)">
                    <animateMotion
                      repeatCount="indefinite"
                      dur="20s"
                      rotate="auto"
                      keyPoints="1;0"
                      keyTimes="0;1"
                    >
                      <mpath href="#orbitPath" />
                    </animateMotion>
                  </circle>

                  {/* Gradient Glow */}
                  <defs>
                    <radialGradient id="glow" cx="50%" cy="50%" r="50%">
                      <stop offset="0%" stopColor="#3AB1F6" stopOpacity=".9" />
                      <stop offset="100%" stopColor="#3AB1F6" stopOpacity="0" />
                    </radialGradient>
                  </defs>
                  <filter
                    id="blur"
                    x="-100%"
                    y="-100%"
                    width="300%"
                    height="300%"
                  >
                    <feGaussianBlur in="SourceGraphic" stdDeviation="20" />
                  </filter>
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-12  md:pt-36 pt-10 pb-8 z-10 relative">
              <div className="flex flex-col lg:gap-6 gap-4">
                <div
                  ref={tagRef}
                  className={`${
                    tagView ? " animate-scaleIn anim-preserve" : "opacity-0"
                  } flex justify-center items-center text-[.9rem] font-inter font-medium rounded-full text-[#3AB1F6] border border-[#3AB1F6] w-max mx-auto py-3 px-6`}
                >
                  Help Center
                </div>
                <div
                  ref={headingRef}
                  className={`${
                    headingView
                      ? "animate-slideUp anim-preserve z-[3]"
                      : "opacity-0 z-0"
                  } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] leading-tight font-bold flex flex-col text-center font-jakarta `}
                >
                  How can we help you today?
                </div>
                <div className=" text-center font-medium px-2 flex flex-col xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter text-[#00000099]">
                  Search our knowledge base for answers to common{" "}
                  <br className=" hidden md:flex" /> questions
                </div>
                <div className=" flex gap-2 items-center lg:w-[40%] md:w-[60%] sm:w-[80%] w-[95%] overflow-hidden bg-white  px-4 py-3 mx-auto rounded-xl">
                  <FiSearch className=" flex-none text-[#3AB1F6] size-6" />
                  <input
                    type="search"
                    placeholder="Search for answers.."
                    className=" flex-grow placeholder:text-[#00000099] bg-transparent outline-none  lg:text-[1.2rem] text-[1rem]  font-inter font-medium "
                  />
                </div>
                <div className=" grid md:grid-cols-3 grid-cols-1 gap-4 md:mx-[5%] mx-[3%] mt-20">
                  {articlesFolder?.map((f, i) => (
                    <div
                      key={i}
                      className=" bg-white p-4 rounded-xl flex flex-col gap-3 hover:scale-[1.05] cursor-pointer transition-all ease-in-out duration-300"
                    >
                      <ReactSVG
                        src={folderIcon}
                        beforeInjection={(svg) => {
                          svg.setAttribute(
                            "class",
                            "xl:w-10 lg:w-8 w-6 h-auto"
                          );
                        }}
                      />
                      <div className=" flex flex-col justify-between h-full lg:gap-4 gap-3">
                        <div className=" flex flex-col gap-2">
                          <h1 className="xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter font-medium">
                            {f.name}
                          </h1>
                          <p className=" xl:text-[1.125rem] text-sm  font-inter">
                            {f.summary}
                          </p>
                        </div>
                        <span className="text-[0.938rem] font-inter text-[#686868]">
                          {f.articles} articles
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className=" grid md:grid-cols-3 grid-cols-1  gap-4  md:mx-[5%] mx-[3%]  ">
            {articlesFolder1?.map((f, i) => (
              <div
                key={i}
                className=" bg-white p-4 rounded-xl flex flex-col gap-3 hover:scale-[1.05] cursor-pointer transition-all ease-in-out duration-300 border border-[#0000001A]"
              >
                <ReactSVG
                  src={folderIcon}
                  beforeInjection={(svg) => {
                    svg.setAttribute("class", "xl:w-10 lg:w-8 w-6 h-auto");
                  }}
                />
                <div className=" flex flex-col justify-between h-full lg:gap-4 gap-3">
                  <div className=" flex flex-col gap-2">
                    <h1 className="xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter font-medium">
                      {f.name}
                    </h1>
                    <p className=" xl:text-[1.125rem] text-sm  font-inter">
                      {f.summary}
                    </p>
                  </div>
                  <span className="text-[0.938rem] font-inter text-[#686868]">
                    {f.articles} articles
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <FAQ />
        <div className="md:mx-[3%] mx-[2%] md:mt-10 mt-0 mb-10">
          <div className=" w-full flex gap-8  bg-[#EBF7FE] rounded-3xl   md:pt-6 md:pl-6 md:py-0 md:px-0 py-5 px-2 ">
            <div className=" flex-1 flex flex-col md:items-start items-center justify-center xl:gap-6 lg:gap-5 gap-5 md:pb-6">
              <div
                ref={iconRef}
                className={`${
                  iconView ? "animate-scaleIn anim-preserve" : "opacity-0"
                }`}
              >
                <ReactSVG
                  src={zeroTypingLogo}
                  beforeInjection={(svg) => {
                    svg.setAttribute("class", "w-auto lg:h-12 md:h-9 h-8");
                  }}
                  className="w-auto"
                />
              </div>
              <div
                ref={headingBannerRef}
                className={`${
                  headingBannerView
                    ? "animate-slideUp anim-preserve z-[3]"
                    : "opacity-0 z-0"
                }lg:text-[2.5rem] text-[2.1rem] tracking-tighter  md:text-left text-center font-jakarta font-semibold text-black`}
              >
                Still have questions?
              </div>
              <div className=" z-[4] relative bg-[#EBF7FE] xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem]  md:text-left text-center text-[1.313rem] font-inter font-medium text-[#00000099]">
                We're here to make things easy. If you couldn’t find the answer
                you were looking for, our support team is just a click away.
                Whether it's a quick question or detailed help you need, we’re
                ready to assist.
              </div>
              <button
                onClick={() => setIsOpen(true)}
                ref={buttonRef}
                className={`${
                  buttonView ? " animate-scaleIn anim-preserve" : "opacity-0"
                } w-max text-[0.938rem] group text-white font-semibold font-inter flex items-center gap-2 p-2 pl-5 rounded-full bg-[#3AB1F6]`}
              >
                Contact Us{" "}
                <span className=" bg-white text-[#3AB1F6] lg:p-2 p-1.5 rounded-full group-hover:rotate-45 transition-all duration-200">
                  <GoArrowUpRight className="lg:size-5 size-4" />
                </span>
              </button>
            </div>
            <div className="flex-1 md:flex hidden justify-center items-end relative  ">
              <ReactSVG
                src={bannerImage}
                className="2xl:w-[55%] xl:w-[63%] lg:w-[87%] h-auto absolute "
                beforeInjection={(svg) => {
                  svg.classList.add("w-full", "h-auto");
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <ContactUs isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Support;
